// material
import React from 'react';
import { alpha, styled } from '@mui/material/styles';
import { Card, Skeleton, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../Utils/formatNumber';
// component
import Iconify from '../../../Components/Dashboard/Iconify';
import { useSelector } from 'react-redux';
// ----------------------------------------------------------------------
const getLoanState = state => state.loansReducer;
const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(3, 0),
  color: theme.palette.primary.darker,
  background: 'rgba(1, 108, 52, 0.19)',
  borderRadius:'16px',
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(5),
  height: theme.spacing(5),
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  // color:'#016C34',
  color:'#FFF',
  backgroundColor:'#016C34'
}));

// ----------------------------------------------------------------------

const TOTAL = 135;

export default function CardActiveLoans() {
  const {totalLoanDetails} = useSelector(getLoanState)
  const TOTAL = totalLoanDetails.totalActiveLoans
  console.log(totalLoanDetails, "TOTALLOANS")
  return (
    <>
    {Object.keys(totalLoanDetails).length === 0 ? (
     <Skeleton variant="rounded" width="212px" height="152px"/>
     ) : (
    <RootStyle>
      <IconWrapperStyle>
        <Iconify icon="icon-park-solid:folder-success" width={22} height={22} />
      </IconWrapperStyle>
      <Typography variant="h5"  fontWeight={700} fontSize={'25px'}>{fShortenNumber(TOTAL)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72, fontSize:'12px' }}>
      Active Loans
      </Typography>
    </RootStyle>
  )}
  </>
);
}
